export const USER_SET = 'USER_SET'
export const USER_UNSET = 'USER_UNSET'
export const GET_USER = 'GET_USER'
